import * as React from 'react'

// Must match Tailwind v4's --breakpoint-md (48rem) so JS and CSS
// agree on the mobile/desktop boundary in every browser and zoom level.
const DESKTOP_QUERY = '(min-width: 48rem)'

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(DESKTOP_QUERY)
    const onChange = () => {
      setIsMobile(!mql.matches)
    }
    mql.addEventListener('change', onChange)
    setIsMobile(!mql.matches)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return !!isMobile
}
